import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQuery';
import { API_TAG_TYPES } from './tagTypes';

/**
 * The one base slice (D-17). It declares the base query, the reauth logic and
 * the frozen tag list, and **no endpoints**.
 *
 * Every feature adds its own with `baseApi.injectEndpoints({ endpoints })` in
 * `features/<track>/api/*Api.ts`, so the worker PWA ships only the endpoints
 * it actually calls.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: API_TAG_TYPES,
  endpoints: () => ({}),
  // Punch state and dashboards go stale in seconds; a cached answer that
  // outlives the shift is worse than a refetch.
  refetchOnReconnect: true,
});

export type BaseApi = typeof baseApi;
